{
  "search": {
    "company_placeholder": "Search company on the internet",
    "no_results": "We couldn't find any match. Try different search terms or check for any typos or spelling error.",
    "actions": {
      "add_to_prospect": "add to prospect",
      "add_to_list": "add to list"
    }
  },
  "fields": {
    "country_label": "Country",
    "head_count_label": "Head Count",
    "industry_label": "Industry",
    "list_label": "List",
    "head_count_any": "Any"
  },
  "prospects": {
    "add_button": "Add Prospect",
    "empty_state": {
      "title": "Your first-degree connection to any professional.",
      "description": "Use Nexl's prospecting tools to connect directly with the right decision makers, using the world's largest and most accurate database of professional emails and LinkedIn profiles.",
      "search_button": "Search for your first prospect"
    },
    "list": {
      "headers": {
        "company": "Company",
        "country": "Country",
        "industry": "Industry",
        "assigned_to": "Assigned to",
        "engagement": "Engagement",
        "last_interaction": "Last Interaction"
      },
      "filters": {
        "relationship_partner": "Relationship Partner"
      },
      "empty_message": "There's no company to show here",
      "clear_selection": "Clear selection"
    },
    "email": {
      "find_contact_details": "Find contact details"
    },
    "add_to_list": {
      "button": "Add to List",
      "validation": {
        "choose_list": "Please choose a list"
      }
    }
  },
  "search_prospects": {
    "table": {
      "headers": {
        "company": "Company",
        "country": "Country",
        "industry": "Industry",
        "linkedin": "LinkedIn",
        "head_count": "Head Count",
        "action": "Action"
      }
    },
    "empty_state": "There's no prospect found match the criteria",
    "no_more_results": "There's no more prospects.",
    "load_more": "Load More"
  },
  "prospects_page": {
    "search_button": "Search Prospects",
    "tab_name": "All Prospects"
  }
}
